import axios from "axios";
import { buildQuery } from "utils/queryUtils";
import * as yup from "yup";

let schema = yup.object().shape({
    code: yup.string().test("not-blank", "code.required", (code) => code?.length > 0),
    name: yup.string().test("not-blank", "name.required", (name) => name?.length > 0),
    value: yup.string().test("not-blank", "value.required", (value) => value?.length > 0),
    calculationUnit: yup.string().test("parameter", "calculationUnit.required", (calculationUnit) => !!calculationUnit),
});

export const validateParameter = (parameter) => {
    return schema.validate(parameter, { abortEarly: false });
};

export const findParameters = (headers, params) => {
    let query = buildQuery(params, []);
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/parameters${query}`, {
        headers,
    });
};

export const createParameter = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_IDP_API_URL}/parameters`, data, {
        headers,
    });
};

export const updateParameter = (headers, id, data) => {
    return axios.patch(`${process.env.REACT_APP_IDP_API_URL}/parameters/${id}`, data, {
        headers,
    });
};

export const deleteParameter = (headers, id) => {
    return axios.delete(`${process.env.REACT_APP_IDP_API_URL}/parameters/${id}`, {
        headers: headers,
    });
};

export const deleteParameters = (headers, ids) => {
    return axios.delete(`${process.env.REACT_APP_IDP_API_URL}/parameters?id=${ids.join()}`, {
        headers: headers,
    });
};
